<script setup>
import {  reactive } from 'vue';
import { format$ } from '@/libraries/HelperFunctions';
import CodesTreatmentHelpVue from './CodesTreatmentHelp.vue';

const props = defineProps(['helpArray', 'xCodes', 'headerText']); // xCodes are [Obj]
const emits = defineEmits(['updateXCodes'])

const state = reactive({
    helpOptions: null,
})

function addHelpArray(helpArray) {
    state.helpOptions = helpArray;
}

function closeHelpMenu() {
    state.helpOptions = null;
}
function toggle(opt){
  if (opt.count > 0) return;
    opt.isSelected = !opt.isSelected;
    increaseOptionCount(opt);
}
function increaseOptionCount(opt){
    opt.count++;
    emits('updateXCodes');
}
function decreaseOptionCount(opt){
    opt.count--;
    if (opt.count <= 0) {
        opt.isSelected = false;
    }
    emits('updateXCodes');
}
function dontAutoSelectWhenAddingOrSubtracting(event){
    event.stopPropagation();
}


</script>
<template>
  <label>{{ headerText }} <i @click="addHelpArray(helpArray)"
            class="fa fa-circle-info"></i></label>
    <div class="code-block applicable" :class="{ selected: opt.isSelected }"
        v-for="(opt) in xCodes" :key="opt" @click="toggle(opt)">
        <div class="info">
            <div class="code">{{ opt.code }}</div>
            <div class="name">{{ opt.name }}</div>
            <div>{{ format$(opt.price) }}</div>
        </div>
        <div v-if="opt.count > 0 && opt.isSelected" class="counter" @click="(event)=>dontAutoSelectWhenAddingOrSubtracting(event)">
            <i class ="fa fa-minus" @click="decreaseOptionCount(opt)"></i>
            <div class="count">{{ opt.count }}</div>
            <i class="fa fa-plus" @click="increaseOptionCount(opt)"></i>
        </div>
    </div>
    <!-- check RDTObject Library, xCodes are Obj w/ rules property -->
    <CodesTreatmentHelpVue  v-if="state.helpOptions" :helpOptions="state.helpOptions" :codeObjects="xCodes" @close="closeHelpMenu"/>
</template>
<style scoped lang="scss">
</style>